import React from 'react';
import PropTypes from 'prop-types';

const Container = ({ children }) => (
  <div className="flex-1 mx-auto max-w-full w-[780px] flex flex-col">
    {children}
  </div>
);

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Container;
